module.exports = __webpack_public_path__ + "media/images/letter-action-9a425e044569922bd98957e1d288f6f8.svg";